export const FETCH_ALERT_MESSAGE = 'FETCH_ALERT_MESSAGE'
export const FETCH_ALERT_MESSAGE_SUCCESS = ' FETCH_ALERT_MESSAGE_SUCCESS'
export const FETCH_ALERT_MESSAGE_FAILED = '  FETCH_ALERT_MESSAGE_FAILED'

export const FETCH_DELETE_ALERT_MESSAGE = 'FETCH_DELETE_ALERT_MESSAGE'
export const FETCH_DELETE_ALERT_MESSAGE_SUCCESS = 'FETCH_DELETE_ALERT_MESSAGE_SUCCESS'
export const FETCH_DELETE_ALERT_MESSAGE_FAILED = 'FETCH_DELETE_ALERT_MESSAGE_FAILED'

export const FETCH_ADD_ALERT_MESSAGE = 'FETCH_ADD_ALERT_MESSAGE'
export const FETCH_ADD_ALERT_MESSAGE_SUCCESS = 'FETCH_ADD_ALERT_MESSAGE_SUCCESS'
export const FETCH_ADD_ALERT_MESSAGE_FAILED = 'FETCH_ADD_ALERT_MESSAGE_FAILED'

export enum AlertStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ALL = 'Success',
  NONE = ''
}
export interface AlertMessage {
  AlertMessageUUID: string
  Name: string
  AppId: string | number
  Text: string
  ValidFrom: string
  ValidTo: string
  CreatedBy: string
  CreatedAt: string
  CriteriaUse: boolean
  Link: string
  Criteria: Array<{
    CriteriaId: number
    Name: string
    Value: string
    Comparison: string
  }>
}
export const editableFields = ['PROFILE ID', 'CUSTOMER NUMBER', 'SHIP-TO-LOCATION', 'SALES REGION', 'CONCEPTS', 'LOCATION']
export const comparisonOptions = ['EQUAL', 'NOT EQUAL']
